var map = {
	"./add-user.svg": 444,
	"./arr-m-r.svg": 1298,
	"./arrow-left.svg": 6950,
	"./arrow-left2.svg": 1410,
	"./arrow-right.svg": 619,
	"./arrow-right2.svg": 4032,
	"./ava-def.svg": 7050,
	"./bookmark-full.svg": 7365,
	"./bookmark.svg": 1745,
	"./calendar-check.svg": 1353,
	"./calendar-plus.svg": 3954,
	"./calendar.svg": 5704,
	"./calendar2.svg": 8574,
	"./calendar3.svg": 2510,
	"./check.svg": 3039,
	"./chevron-left.svg": 3176,
	"./chevron-right.svg": 551,
	"./circ-galka.svg": 7734,
	"./clock.svg": 3310,
	"./download.svg": 4215,
	"./file.svg": 7584,
	"./folder.svg": 1433,
	"./globe.svg": 4081,
	"./ic-edit.svg": 8404,
	"./ic-pay.svg": 653,
	"./ico-calendar.svg": 5665,
	"./ico-del.svg": 7362,
	"./ico-draft.svg": 9523,
	"./ico-favorite.svg": 276,
	"./ico-galka.svg": 4065,
	"./ico-h-calendar.svg": 5328,
	"./ico-h-favorite.svg": 9093,
	"./ico-h-message.svg": 4332,
	"./ico-h-notification.svg": 4586,
	"./ico-h-user.svg": 2021,
	"./ico-pdf.svg": 7317,
	"./ico-plus-circ.svg": 1678,
	"./ico-save-draft.svg": 4380,
	"./ico-time.svg": 9636,
	"./ico-user.svg": 2624,
	"./map-marker.svg": 8758,
	"./mf-logo.svg": 380,
	"./mf-small.svg": 7642,
	"./plane.svg": 2136,
	"./plane_old.svg": 7404,
	"./plus.svg": 6999,
	"./search.svg": 2706,
	"./shield.svg": 1926,
	"./stars.svg": 4177,
	"./tag-master.svg": 9236,
	"./tag-play.svg": 7561,
	"./trophy.svg": 7899,
	"./user.svg": 1030,
	"./users.svg": 6919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4039;